/**
 * Урок, который ещё создаётся на сервере: плашка сразу стоит выбранной (как у
 * обычного урока), а под ней — пустая лента. Автор видит результат клика
 * мгновенно; настоящий урок подменит заглушку, как только ответит сервер.
 */
export const PendingLessonPill = ({ number, label }: { number: number; label: string }) => (
  <div
    data-testid="lesson-creating-skeleton"
    aria-busy="true"
    className="flex h-10 shrink-0 items-center gap-2 rounded-full bg-brand/20 py-0 pl-1.5 pr-4 text-sm text-foreground"
  >
    <span className="flex size-7 items-center justify-center rounded-full bg-brand text-[13px] font-semibold text-brand-foreground">
      {number}
    </span>
    {label}
  </div>
)
